import { editApplicationSummary, fetchChallengeScoreSummary } from '@actions/challenges';
import {
    getChallengesPostError,
    getChallengesIsPosting,
    getChallengesPostSuccess,
} from '@selectors/challenges';
import useForm from '@components/form/hooks/useForm';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AssessmentSummary } from 'src/types/shared/Assessments';

const useEditAssessment = (row: AssessmentSummary) => {
    const dispatch = useDispatch();

    const isPosting = useSelector(getChallengesIsPosting);
    const postSuccess = useSelector(getChallengesPostSuccess);
    const postError = useSelector(getChallengesPostError);
    const prevSuccess = usePrevious(postSuccess);

    const initialState: Form = {
        summary: row.submission.overallScoreSummary || '',
    };

    const [formState, handleChange] = useForm<Form>(initialState);

    const handleSubmit = () => {
        dispatch(editApplicationSummary(row.submission.id, formState));
    };

    useEffect(() => {
        if (postSuccess && !prevSuccess)
            dispatch(fetchChallengeScoreSummary(row.submission.challengeID));
    }, [dispatch, row.submission.challengeID, prevSuccess, postSuccess]);

    return {
        formState,
        handleChange,
        handleSubmit,
        isPosting,
        postError,
        postSuccess,
        prevSuccess,
    };
};
interface Form {
    summary: string;
}

export default useEditAssessment;
